import "./css/style.css";
import * as Fake from "@faker-js/faker"
export default function ErrorPage(props, error) {

  if (props.error){
    return (
      <>
        <div className="coverpage disablescroll errorpage centerelements">
          <div className="box">
            <div className="centerelements title">
              <h1>!UNRECOVERABLE ERROR! - {props.error}</h1>
            </div>
            <div className="text">
  
            {props.information}
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="coverpage disablescroll errorpage centerelements">
          <div className="box">
            <div className="centerelements title">
              <h1>!UNRECOVERABLE ERROR! - {error}</h1>
            </div>
            <div className="text">
  
            {error.message}
            </div>
          </div>
        </div>
      </>
    );
  }

}
